export class RequestUserInformation {
  id: number;
  firstName: string;
  surname: string;
  mobilePhoneCountryCode: string;
  mobilePhonePrefix: string;
  mobilePhoneNumber: string;
  supplierProfileCode: string;
  refNo: string;

  public constructor(init?: Partial<RequestUserInformation>) {
    Object.assign(this, init);
  }
}
